/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DlsgPolicyPlan } from '../models/DlsgPolicyPlan';
import { ScheduleMode } from '../models/ScheduleMode';

export class DlsgPolicy {
  /**
  * Backup policy ID.
  */
  'id': string;
  /**
  * DLSG policy display name.
  */
  'name': string;
  /**
  * List of cloud-provider-assigned resource IDs to include in the dlsg policy. 
  */
  'resourceInclusion': Array<string>;
  'policyPlan': DlsgPolicyPlan;
  /**
  * The number of resources attached to the policy
  */
  'attachedResources'?: number;
  'scheduleMode'?: ScheduleMode;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceInclusion",
      "baseName": "resourceInclusion",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "policyPlan",
      "baseName": "policyPlan",
      "type": "DlsgPolicyPlan",
      "format": ""
    },
    {
      "name": "attachedResources",
      "baseName": "attachedResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "scheduleMode",
      "baseName": "scheduleMode",
      "type": "ScheduleMode",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DlsgPolicy.attributeTypeMap;
  }

  public constructor() {
  }
}



